import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import App from "./App";
import Store from "../stores";
import theme from "../lib/theme";

const store = new Store();

// Remove the server-side injected CSS
const jssStyles = document.querySelector("#jss-server-side");
if (jssStyles) {
  jssStyles.parentElement.removeChild(jssStyles);
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider verbStore={store.verbStore}>
          <App />
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
